import daLiJePoljeValidno from "../../../../utils/daLiJePoljeValidno";
import {
  FormControl,
  Input,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { useFormContext } from "react-hook-form";
import { PorukaGreskePolja } from "../../../index";
import { ChangeEvent, useMemo } from "react";

const Index = ({ nazivPolja }: any) => {
  const { register, getValues, setValue, watch } = useFormContext();
  const value = getValues(`${nazivPolja}.oznaka`);
  const drzave = getValues("drzave");
  const watchField = watch(`${nazivPolja}.oznaka`);
  const watchFieldEuSifra = watch(`${nazivPolja}.euSifra`);

  return (
    <>
      <FormControl
        fullWidth
        error={
          !daLiJePoljeValidno(`${nazivPolja}.oznaka`) ||
          !daLiJePoljeValidno(`${nazivPolja}.euSifra`)
        }
      >
        <InputLabel id={`${nazivPolja}.oznaka`}>
          *Država izdavatelj (Issuer country)
        </InputLabel>
        <Select
          labelId={`${nazivPolja}.oznaka`}
          id={`${nazivPolja}.oznaka`}
          value={value || ""}
          label={`Izdavatelj (Issuer)`}
          variant={"standard"}
          {...register(`${nazivPolja}.oznaka`)}
          onChange={(e: SelectChangeEvent<any>) => {
            setValue(`${nazivPolja}.oznaka`, e.target.value);
            setValue(
              `${nazivPolja}.euSifra`,
              drzave.find((drzava: any) => drzava.oznaka === e.target.value)
                .euSifra
            );
          }}
        >
          {drzave.map((drzava: any, key: number) => (
            <MenuItem key={key} value={drzava.oznaka}>
              {drzava.naziv}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <input type={"hidden"} {...register(`${nazivPolja}.euSifra`)} />
      <PorukaGreskePolja nazivPolja={`${nazivPolja}.oznaka`} />
      <PorukaGreskePolja nazivPolja={`${nazivPolja}.euSifra`} />
    </>
  );
};

export default Index;
